import React, { useState, useEffect } from 'react'
import './Toggle.scss'

const Toggle = ({ label = '', value, onUpdate, errorMessages = [], isRequired, isDisabled }) => {
    const [_value, _setValue] = useState(value)

    useEffect(() => {
        _setValue(value)
    }, [value])

    const onChange = () => {
        if (!isDisabled) {
            _setValue(!_value)
            try {
                onUpdate(!_value)
            } catch (err) {
                console.error(err)
            }
        }
    }

    return (
        <div className="common-toggle">
            <div className="common-toggle__slider-wrapper">
                <span className={`common-toggle__slider ${_value ? 'checked' : ''}`} onClick={onChange} />
            </div>
            <p className="common-toggle__label" onClick={onChange}>
                {label.length ? label : null}
            </p>
        </div>
    )
}

export default Toggle
